<template>
  <div>
    <v-btn  text
            @click.stop="dialog = true;"
    >Change Password
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
    >
      <ChangePasswordForm 
        v-if="dialog" 
        @cancel="dialog = false"
        @ok="dialog = false"
      ></ChangePasswordForm>
    </v-dialog>
  </div>
</template>

<script>
import ChangePasswordForm from "./ChangePasswordForm";

export default {
  name:       "ChangePassword",
  components: { ChangePasswordForm },
  data:       () => ({
    dialog: false
  })
}
</script>

<style scoped>
</style>
